/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PolicyCategory } from './PolicyCategory';
import {
    PolicyCategoryFromJSON,
    PolicyCategoryFromJSONTyped,
    PolicyCategoryToJSON,
    PolicyCategoryToJSONTyped,
} from './PolicyCategory';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdatePolicyRequest
 */
export interface UpdatePolicyRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdatePolicyRequest
     */
    policyId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdatePolicyRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePolicyRequest
     */
    displayText: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePolicyRequest
     */
    isRequired: boolean;
    /**
     * 
     * @type {PolicyCategory}
     * @memberof UpdatePolicyRequest
     */
    category: PolicyCategory;
}



/**
 * Check if a given object implements the UpdatePolicyRequest interface.
 */
export function instanceOfUpdatePolicyRequest(value: object): value is UpdatePolicyRequest {
    if (!('policyId' in value) || value['policyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayText' in value) || value['displayText'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function UpdatePolicyRequestFromJSON(json: any): UpdatePolicyRequest {
    return UpdatePolicyRequestFromJSONTyped(json, false);
}

export function UpdatePolicyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePolicyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'policyId': ApiUserTasksGetPageParameterFromJSON(json['policyId']),
        'name': json['name'],
        'displayText': json['displayText'],
        'isRequired': json['isRequired'],
        'category': PolicyCategoryFromJSON(json['category']),
    };
}

export function UpdatePolicyRequestToJSON(json: any): UpdatePolicyRequest {
    return UpdatePolicyRequestToJSONTyped(json, false);
}

export function UpdatePolicyRequestToJSONTyped(value?: UpdatePolicyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policyId': ApiUserTasksGetPageParameterToJSON(value['policyId']),
        'name': value['name'],
        'displayText': value['displayText'],
        'isRequired': value['isRequired'],
        'category': PolicyCategoryToJSON(value['category']),
    };
}

